module.exports = __webpack_public_path__ + "img/wrong.b1dd3508.png";